var header = (function() {

    var config = {
        options: {
            expandedClass: 'is-expanded',
            mobileBreakpoint: 1024,
            speed: 300,
            scroll: {
                scrolledClass: 'is-scrolled',
                retractedClass: 'is-retracted',
                threshold: 1, // how much user needs to scroll before function is triggered
                offset: 1 // offset from the top of the page
            }
        }
    };

    var didScroll;
    var lastScrollTop = 0;

    var refresh = function () {
        // var mql = window.matchMedia("screen and (min-width: " + config.options.mobileBreakpoint + "px)");
        // if (mql.matches){
        //     jQuery('.component-header .menu').show();
        //     jQuery('.component-header').removeClass(config.options.expandedClass);
        // } else {
        //     jQuery('.component-header .menu').hide();
        //     jQuery('.component-header').removeClass(config.options.expandedClass);
        // }
    };

    var toggle = function () {
        jQuery('.component-header').toggleClass(config.options.expandedClass);
        jQuery('.component-header .menu').slideToggle(config.options.speed);
    };

    var open = function () {
        if (!jQuery('.component-header').hasClass(config.options.expandedClass)) {
            jQuery('.component-header .menu').slideDown(config.options.speed);
            jQuery('.component-header').addClass(config.options.expandedClass);
        }
    };

    var close = function () {
        if (jQuery('.component-header').hasClass(config.options.expandedClass)) {
            jQuery('.component-header .menu').slideUp(config.options.speed);
            jQuery('.component-header').removeClass(config.options.expandedClass);
        }
    };

    var hasScrolled = function () {
        var scrollTop = jQuery(window).scrollTop();

        // add scrolled class
        if (scrollTop >= config.options.scroll.offset) {
            jQuery('.component-header').addClass(config.options.scroll.scrolledClass);
        } else {
            jQuery('.component-header').removeClass(config.options.scroll.scrolledClass);
        }

        // Make sure they scroll more than threshold
        if (Math.abs(lastScrollTop - scrollTop) <= config.options.scroll.threshold)
            return;

        if (scrollTop >= config.options.scroll.offset && scrollTop > lastScrollTop) {
            jQuery('.component-header').addClass(config.options.scroll.retractedClass);
        } else {
            jQuery('.component-header').removeClass(config.options.scroll.retractedClass);
        }

        lastScrollTop = scrollTop;
    };

    var bindFunctions = function() {
        // open/close
        jQuery('.header__expander').click(function() {
            toggle();
        });

        // close with clicking on body
        jQuery('body').click(function(){
            close();
        });

        jQuery('.component-header').click(function(e){
            e.stopPropagation();
        });

        // close with escape
        jQuery(document).keyup(function(e) {
            if (jQuery('.component-header').hasClass(config.options.expandedClass) && e.keyCode === 27) { // escape
                close();
            }
        });

        // scroll
        if (config.options.scroll) {
            jQuery(window).scroll(function(){
                didScroll = true;
            });

            setInterval(function() {
                if (didScroll) {
                    hasScrolled();
                    didScroll = false;
                }
            }, 250);
        }
    };

    var init = function () {
        bindFunctions();
        refresh();
    };

    return {
        init: init,
        refresh: refresh,
        open: open,
        close: close,
        toggle: toggle
    }
})();

header.init();
